import React from 'react';
const milestones = [{
  status: 'DONE',
  label: 'Discovery & Planning Alpha',
  detail: 'Live in App Store',
  statusColor: '#34d399',
  statusBg: 'rgba(52, 211, 153, 0.15)',
  statusBorder: 'rgba(52, 211, 153, 0.3)',
  textColor: 'rgba(255,255,255,0.9)',
  borderColor: '#34d399'
}, {
  status: 'IN MOTION',
  label: 'Go-to-Market',
  detail: 'March Madness · Miami Beach activation · Social seeding',
  statusColor: '#4A90D9',
  statusBg: 'rgba(74, 144, 217, 0.15)',
  statusBorder: 'rgba(74, 144, 217, 0.3)',
  textColor: '#ffffff',
  borderColor: '#4A90D9'
}, {
  status: 'NEXT',
  label: 'Routing Engine',
  detail: 'Generative pedestrian routing',
  statusColor: 'rgba(255,255,255,0.35)',
  statusBg: 'rgba(255,255,255,0.05)',
  statusBorder: 'rgba(255,255,255,0.1)',
  textColor: 'rgba(255,255,255,0.5)',
  borderColor: 'rgba(255,255,255,0.15)'
}];
export function TractionSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-388">
      <div className="flex flex-row w-full h-full min-h-0" data-id="element-389">
        {/* Left Panel — 45% text on pure black */}
        <div className="flex flex-col justify-center w-[45%] flex-shrink-0 min-h-0 overflow-hidden relative" style={{
        backgroundColor: '#0d1520',
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-390">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.25rem, 0.5vw, 0.4rem)',
          animationDelay: '0.1s'
        }} data-id="element-391">
            This is real.
          </p>

          {/* Heading */}
          <h1 className="font-black tracking-tight leading-[1.05] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
          animationDelay: '0.15s'
        }} data-id="element-392">
            Alpha product is live. GTM is in testing.
          </h1>

          {/* Subtitle */}
          <p className="animate-fade-slide" style={{
          color: 'rgba(255,255,255,0.45)',
          fontSize: 'var(--body-size)',
          lineHeight: '1.5',
          maxWidth: '95%',
          animationDelay: '0.18s'
        }} data-id="element-393">
            No fundraise. No paid ads. Just product and momentum.
          </p>

          {/* Milestone Timeline */}
          <div className="flex flex-col w-full" style={{
          gap: 'clamp(0.5rem, 1vw, 0.85rem)',
          marginTop: 'clamp(1.5rem, 3vw, 2.5rem)',
          marginBottom: 'clamp(1.5rem, 3vw, 2.5rem)'
        }} data-id="element-394">
            {milestones.map((m, i) => <div key={m.status} className="animate-fade-slide rounded-lg flex items-start" style={{
            borderLeft: `3px solid ${m.borderColor}`,
            backgroundColor: 'rgba(255,255,255,0.03)',
            padding: 'clamp(0.6rem, 1.2vw, 1rem) clamp(0.85rem, 1.5vw, 1.5rem)',
            animationDelay: `${0.25 + i * 0.1}s`
          }} data-id="element-395">
                {/* Status chip */}
                <div className="flex-shrink-0 rounded-full font-bold uppercase tracking-[0.1em]" style={{
              color: m.statusColor,
              backgroundColor: m.statusBg,
              border: `1px solid ${m.statusBorder}`,
              fontSize: 'clamp(0.55rem, 0.85vw, 0.7rem)',
              padding: 'clamp(2px, 0.3vw, 4px) clamp(8px, 1.2vw, 14px)',
              marginRight: 'clamp(0.6rem, 1.2vw, 1rem)',
              marginTop: 'clamp(1px, 0.2vw, 3px)',
              whiteSpace: 'nowrap'
            }} data-id="element-396">
                  {m.status}
                </div>

                {/* Content */}
                <div className="min-w-0" data-id="element-397">
                  <p className="font-bold leading-snug" style={{
                color: m.textColor,
                fontSize: 'clamp(1rem, 1.8vw, 1.35rem)',
                marginBottom: 'clamp(0.1rem, 0.2vw, 0.15rem)'
              }} data-id="element-398">
                    {m.label}
                  </p>
                  <p className="leading-snug" style={{
                color: 'rgba(255,255,255,0.4)',
                fontSize: 'var(--body-size)'
              }} data-id="element-399">
                    {m.detail}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Right Panel — Product Screenshot */}
        <div className="flex-1 flex items-center justify-center relative overflow-hidden" style={{
        padding: 'var(--slide-padding)',
        backgroundColor: '#0d1520'
      }} data-id="element-400">
          <img src="https://cdn.magicpatterns.com/uploads/1KmJUX3HZz7ogVcsSmvY9r/Screenshot_2026-04-03_at_1.38.18_PM.png" alt="Navi — Arizona Tech Week & Venture Madness 2026 guide" className="w-full h-full object-contain rounded-2xl animate-fade-slide" style={{
          maxHeight: '85vh',
          boxShadow: '0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)',
          animationDelay: '0.4s'
        }} data-id="element-401" />
        </div>
      </div>
    </section>;
}